import { CSSProperties } from 'react';

type Offsets = { top?: number; bottom?: number; left?: number };

// Character images were placed pixel perfect at 400px wide.
// The width now shrinks with the viewport (width and height), and the offsets scale with it
// so the character keeps the same position relative to the card.
export const characterStyle = (aspectRatio: number, offsets: Offsets = {}): CSSProperties => {
  const width = `min(400px, 35vw, ${Math.round(50 * aspectRatio)}vh)`;
  const scaled = (px = 0) => `calc(${width} * ${px / 400})`;

  return {
    objectFit: 'contain',
    flexShrink: 0,
    width,
    aspectRatio,
    marginTop: scaled(offsets.top),
    marginBottom: scaled(offsets.bottom),
    marginLeft: scaled(offsets.left),
  };
};
